export default {
  "overviewTitle": "Recharge overview",
  "coreMetrics": "Key metrics",
  "monthOverMonth": "MoM",
  "noPreviousMonth": "No previous-month data",
  "revenueTrend": "Recharge revenue over the last 6 months",
  "trendNote": "Unit: CNY 10,000 · Peak: {peak}",
  "topCompanies": "Top 10 organizations by recharge",
  "rank": "Rank",
  "company": "Company / Organization",
  "rechargeCount": "Recharges",
  "rechargeTotal": "Total recharged",
  "emptyRecords": "No recharge records",
  "monthOrderCount": "{count} recharge orders this month",
  "resourceShare": "Recharge share by resource",
  "resourceShareCenter": "Resource\nshare",
  "packageDistribution": "Recharge pack sales mix",
  "packageSalesCenter": "Pack\nsales",
  "none": "No data",
  "tenThousand": " ×10k",
  "orderUnit": "orders",
  "companyUnit": "organizations",
  "monthOrders": "Recharge orders this month",
  "monthRevenue": "Recharge revenue this month",
  "monthCompanies": "Recharging organizations this month",
  "totalRevenue": "Total recharge revenue",
  "storageRecharges": "Cloud storage recharges",
  "smsRecharges": "SMS recharges",
  "aiRecharges": "AI retouching recharges",
  "averageOrder": "Average order value",
  "messages": "messages",
  "images": "images",
  "cards": "cards",
  "ai": "AI retouching",
  "storage": "Cloud storage",
  "sms": "SMS notifications",
  "card": "Name-card credits",
  "manageTitle": "Recharge pack management",
  "createResource": "Add resource type",
  "guide": "Recharge packs let organizations add AI retouching, cloud storage, SMS and name-card credits beyond their membership quota. Each resource offers multiple tiers and can be purchased again as needed.",
  "aiCategory": "AI services",
  "resourceCategory": "Resource recharge",
  "summaryDefault": "Flexible resource top-ups for organizations",
  "descriptionDefault": "No resource description yet.",
  "packageTiers": "Pack tiers",
  "tierCount": "{count} tiers",
  "minPrice": "Lowest price",
  "maxPrice": "Highest price",
  "editResource": "Edit resource",
  "configurePackages": "Configure packs",
  "delete": "Delete",
  "emptyResources": "No recharge resource types configured",
  "resourceName": "Resource name",
  "resourceNamePlaceholder": "e.g. Cloud storage",
  "displayIcon": "Display icon",
  "category": "Category",
  "unit": "Unit",
  "unitPlaceholder": "e.g. GB / messages / images",
  "coverUrl": "Cover image URL (optional)",
  "optional": "Optional",
  "coverUpload": "Upload cover (optional)",
  "clickUpload": "Upload cover",
  "coverHint": "JPG, PNG, WEBP or GIF, up to 10 MB. The cover is uploaded and registered when you save.",
  "summary": "Short summary",
  "description": "Pack description",
  "initialPackage": "Initial pack",
  "packageName": "Pack name",
  "packageNamePlaceholder": "e.g. 50 GB starter pack",
  "quantity": "Credit quantity",
  "price": "Price (CNY)",
  "tag": "Tag",
  "tagPlaceholder": "e.g. Popular",
  "cancel": "Cancel",
  "saveChanges": "Save changes",
  "confirmCreate": "Confirm creation",
  "packageDialogTitle": "Configure packs · {name}",
  "packageTip": "Configure multiple packs for this resource. Enter -1 for unlimited credit. Each pack is valid for 1 year. Keep at least one pack.",
  "addTier": "+ Add pack tier",
  "saveConfiguration": "Save configuration",
  "iconStorage": "Cloud storage",
  "iconImages": "Image assets",
  "iconCards": "Cards / Coupons",
  "iconAi": "AI services",
  "iconGeneric": "General resources",
  "iconFiles": "File resources",
  "iconDocuments": "Documents",
  "iconDocumentService": "Document services",
  "iconCollection": "Resource collection",
  "iconCamera": "Camera images",
  "iconVideo": "Video services",
  "iconLive": "Live video",
  "iconAudio": "Audio services",
  "iconNotifications": "Notifications",
  "iconSmart": "Smart processing",
  "iconAnalytics": "Analytics",
  "iconNetwork": "Network",
  "iconDevices": "Devices",
  "iconPresentation": "Presentations",
  "iconPurchase": "Purchasing",
  "iconWallet": "Account recharge",
  "iconTime": "Time credits",
  "iconAcceleration": "Acceleration",
  "iconFeatured": "Featured services",
  "iconBox": "Resource pack",
  "requiredName": "Enter a resource name",
  "requiredUnit": "Enter a unit",
  "requiredInitialName": "Enter the initial pack name",
  "validImage": "Select a valid image",
  "coverTooLarge": "The cover must not exceed 10 MB",
  "missingObjectKey": "Upload failed: missing object_key",
  "saveSuccess": "Saved",
  "saveFailed": "Could not save",
  "atLeastOnePackage": "Keep at least one complete pack",
  "packagesSaved": "Pack configuration saved",
  "deleteConfirm": "Delete resource type “{name}”?",
  "deleteTitle": "Delete resource type",
  "deleted": "Deleted",
  "unlimited": "Unlimited",
  "rechargeTimes": "{count}"
}
